var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from "react";
import * as Styled from "./CellStyles";
import { debounce } from "@/components/Table/TableUtils";
var TOLERANCE = 2;
var Cell = function (_a) {
    var children = _a.children, crop = _a.crop, tooltip = _a.tooltip, _b = _a.isLastRow, isLastRow = _b === void 0 ? false : _b, onClick = _a.onClick, style = _a.style;
    var contentRef = useRef(null);
    var _c = __read(useState(false), 2), isTruncated = _c[0], setIsTruncated = _c[1];
    useEffect(function () {
        if (!contentRef.current)
            return;
        var checkTruncation = debounce(function () {
            if (!contentRef.current)
                return;
            var _a = contentRef.current, offsetWidth = _a.offsetWidth, scrollWidth = _a.scrollWidth;
            setIsTruncated(scrollWidth - TOLERANCE > offsetWidth);
        }, 100);
        // Check if ResizeObserver is available
        if (typeof ResizeObserver === 'undefined') {
            console.warn('ResizeObserver is not available in Cell component');
            return;
        }
        var resizeObserver = null;
        try {
            resizeObserver = new ResizeObserver(checkTruncation);
            resizeObserver.observe(contentRef.current);
        }
        catch (error) {
            console.warn('Failed to create ResizeObserver in Cell component:', error);
            return;
        }
        return function () {
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        };
    }, []);
    return (React.createElement(Styled.CellWrapper, { onClick: onClick, style: style },
        React.createElement(Styled.Cell, { crop: crop, ref: contentRef }, children),
        !!tooltip && isTruncated && (React.createElement(Styled.Tooltip, { bottom: isLastRow }, String(tooltip)))));
};
export default Cell;
//# sourceMappingURL=data:application/json;base64,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